/**
 * Tools Page - Wrapper component that imports the modular ToolsPage
 * Maintains backward compatibility while using new modular structure
 */

import React from "react";

import ToolsPage from "@/components/tools/ToolsPage";

const Tools: React.FC = () => {
  return <ToolsPage />;
};

export default Tools;
